/**
 * Call on a date picker to transform it into a "to"|indefinite picker. Datepicker / inlineEdit must be called on it /before/ calling this
 * Condition, the "to" date MUST have a valid ID 
 * 
 * TODO: this is a helper, move to /backend from /seekom
 * 
 */
(function($){
	$.fn.indefiniteDate = function(extraAction){
		var element = $(this);

		var refresh = function($elem) {
            if($elem.val() == '')
                $elem.parent().find('.ui-datepicker-indefinite-menu').css('visibility', 'hidden');
            else
                $elem.parent().find('.ui-datepicker-indefinite-menu').css('visibility', 'visible');
        };

		element.datepicker('option', 'autoSize', true);

        // Only bind the events on the first call, otherwise refresh
        if(element.is('.indefinit_d')) {
            refresh(element);
            return element;
        }

        // Handle things differently depending on the user pref
        if(USER_PREF.indefiniteDateMode == 'true'){
            // Indefinite Mode
            element.val('').change();
        }

		element.addClass('indefinit_d');
		
		if($('#' + element.attr('id') + '-indefwrapper').length > 0){
			var wrapper = $('#' + element.attr('id') + '-indefwrapper');
		}
		else {
			var wrapper = $('<div id="' + element.attr('id') + '-indefwrapper" class="indef-wrapper"></div>')
			.insertBefore(element);
			
			element.appendTo(wrapper);
		}

		var afterMe = element;
		
		// The date picker cannot be altered directly, so we need to add an element to handle the "indefinite" values
		var vis = (element.val() == 'indefinite') ? 'hidden' : 'visible';
		
		if(wrapper.find('.ui-datepicker-indefinite-menu').length == 0){
			$('<button type="button" class="ui-datepicker-indefinite-menu" data-joinwith="' + element.attr('id') + '" style="visibility:' + vis + '"></button>')
				.appendTo(wrapper);
			
			wrapper.find('.ui-datepicker-indefinite-menu').button({
				text: false,
				icons: {
					secondary: 'ui-icon-infinite'
				}
			})
			.bind('click', function(){
				var dp = $(this).parent().find('#' + $(this).data('joinwith'));
				dp.val('').change();
				if (typeof extraAction === 'function') {
				    extraAction();
                }
			})
			.alerts().alerts('add', 'help', {'id':'indef', 'message': 'Set to indefinite'});
		}
		
		element.bind('change', function(event){
			refresh($(this));
		}).change();
		
		return element;
	};
	
	$('body').delegate('.ui-datepicker-indefinite', 'click', function(){
		
	});
})(jQuery);